/**
 * Light dismiss for the cart sheet.
 *
 * Above the theme's modal breakpoint the drawer opens with `panel.show()`
 * rather than `showModal()`, so there is no backdrop and the theme's own
 * backdrop-click handler is inert. A sheet that only covers a strip of the page
 * needs a click outside to close it, so that is wired up here.
 */
const DRAWER_ID = 'cart-drawer';

document.addEventListener(
  'pointerdown',
  (event) => {
    const drawer = document.getElementById(DRAWER_ID);
    if (!drawer) return;

    const dialog = drawer.querySelector('dialog');
    if (!dialog?.open) return;

    const target = event.target;
    if (!(target instanceof Element)) return;

    // Inside the sheet itself
    if (target.closest(`#${DRAWER_ID}`)) return;

    // Any other open dialog on top of it — the quick add modal, for one
    const nested = target.closest('dialog');
    if (nested && nested !== dialog) return;

    // The cart button toggles the drawer itself; closing here would fight it
    if (target.closest('.header-actions__cart-icon, .action__cart')) return;

    drawer.close?.();
  },
  true
);

/**
 * Cascade on open.
 *
 * The stagger is driven by a class rather than by [open], because the drawer
 * re-renders through the Section Rendering API on every quantity change — tying
 * the animation to the open state would replay it each time.
 */
const CASCADE = 'nexo-cascade';
const CASCADE_MS = 1100;

function watchCascade() {
  const drawer = document.getElementById(DRAWER_ID);
  const dialog = drawer?.querySelector('dialog');
  if (!dialog || dialog.dataset.nexoCascadeBound) return;

  dialog.dataset.nexoCascadeBound = 'true';
  let timer = 0;

  new MutationObserver(() => {
    if (!dialog.open) {
      dialog.classList.remove(CASCADE);
      return;
    }

    dialog.classList.add(CASCADE);
    clearTimeout(timer);
    timer = setTimeout(() => dialog.classList.remove(CASCADE), CASCADE_MS);
  }).observe(dialog, { attributes: true, attributeFilter: ['open'] });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', watchCascade, { once: true });
} else {
  watchCascade();
}
